import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Cobranza", items: [
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonos", desc: "Pagos recibidos", enabled: !!user.abonos },
      { label: "Abonos Agrupado", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonosAgrupado", desc: "Agrupado por cliente", enabled: !!user.abonos },
      { label: "Estado de Cuenta", icon: "fas fa-file-invoice-dollar", color: "#6366f1", href: "/EstadoCuenta", desc: "Saldos de clientes", enabled: !!user.edoCtaClientes },
      { label: "Antiguedad Saldos", icon: "fas fa-dollar-sign", color: "#ef4444", href: "/AntiguedadSaldosVencido", desc: "Saldos vencidos", enabled: !!user.abonos },
      { label: "Reporte Ingresos", icon: "fas fa-dollar-sign", color: "#3b82f6", href: "/ListadoAbonosGeneral", desc: "Ingresos generales", enabled: !!user.abonos },
    ]},
    { section: "Ventas", items: [
      { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#10b981", href: "/ListadoVentas", desc: "Listado de ventas", enabled: !!user.menu_ventas },
      { label: "Ventas sin Evidencia", icon: "fas fa-ban", color: "#f59e0b", href: "/ListadoVentasNoEvidencia", desc: "Falta evidencia", enabled: !!user.menu_ventas },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevolucionesAdmin", desc: "Devoluciones", enabled: !!user.menu_devolucionesAdmin },
    ]},
    { section: "Cuentas", items: [
      { label: "Anticipos", icon: "fas fa-hand-holding-usd", color: "#14b8a6", href: "/ListadoAnticipos", desc: "Anticipos de clientes", enabled: !!user.menuAnticipos },
      { label: "Saldo Inicial", icon: "fas fa-money-check-alt", color: "#64748b", href: "/ListadoSaldoInicial", desc: "Saldos iniciales", enabled: !!user.notasCargo },
      { label: "Comisiones", icon: "fas fa-percentage", color: "#8b5cf6", href: "/ListadoComisiones", desc: "Comisiones de vendedores", enabled: !!user.comisiones },
      { label: "Edo. Cta. Vendedores", icon: "fas fa-list-ul", color: "#8b5cf6", href: "/EstadoCuentaVendedores", desc: "Por vendedor", enabled: !!user.estado_cuenta_vendedores },
    ]},
    { section: "Bancos", items: [
      { label: "Bancos", icon: "fas fa-university", color: "#3b82f6", href: "/Bancos", desc: "Cuentas bancarias", enabled: !!user.bancos },
      { label: "Movimientos Bancos", icon: "fas fa-list-ol", color: "#3b82f6", href: "/MovimientosBancos", desc: "Movimientos", enabled: !!user.bancos },
      { label: "Traspaso Dinero", icon: "fas fa-dollar-sign", color: "#06b6d4", href: "/ListadoTraspasosDinero", desc: "Entre cuentas", enabled: !!user.gastosTiendas },
      { label: "Empresas", icon: "fas fa-industry", color: "#64748b", href: "/Empresas", desc: "Razones sociales", enabled: !!user.bancos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Admin"
      descripcion="Cobranza, cuentas y bancos"
      icono="fas fa-file-invoice-dollar"
      color="#6366f1"
      secciones={SECCIONES}
    />
  );
}

export default BotonesAdmin;
